import { clsx } from 'clsx';
import { useEffect } from 'react';
import { Tab as MuiTab, TabProps as MuiTabProps } from '@mui/material';
import { useTabsContext } from './useTabsContext';
import styles from './Tabs.module.scss';
import { TabValueType } from './interfaces';

export interface TabLabelProps extends MuiTabProps {
  compact?: boolean;
  value: TabValueType;
}

export function TabLabel({ value, label, compact, ...otherProps }: TabLabelProps) {
  const { panelComponentMountMap, onClick } = useTabsContext();

  useEffect(() => {
    panelComponentMountMap.set(value, false);
  }, []);

  return (
    <MuiTab
      id={`tab-${value}`}
      role='tab'
      aria-controls={`tabpanel-${value}`}
      aria-label={`tab-${value}`}
      classes={{
        root: clsx(styles.tabLabel, compact && styles.compact),
        selected: styles.tabLabelSelected
      }}
      value={value}
      label={label}
      onClick={() => onClick(value)}
      {...otherProps}
    />
  );
}
